import UniversalMediaElement from '../widgets/js/UniversalMediaElement';
import Wine from '../widgets/js/Wine';
import {
    ContainerArticle,
    ContainerWines,
    ContainerSearchInput,
    SearchInput,
    ContainerFilteredOptionsForSearch,
    FilteredOptionsForSearch,
    SpanForListItemsNull
} from '../js/Styles'; // Ajusta la ruta según tu estructura

import React, { useEffect, useState } from 'react';
import axios from 'axios';

function Item8InFoodMenu() {
    const [wines, setWines] = useState([]); // Estado para almacenar los productos

    const [searchTerm, setSearchTerm] = useState('');
    const [filteredWines, setFilteredWines] = useState([]);
    const [filteredOption, setFilteredOption] = useState(0);
    const [filteredOptionString, setFilteredOptionString] = useState('nombre');
    const [images_for_carousel, setImagesForCarousel] = useState([]); // Estado para almacenar las imagenes del carrousel
    const apiDomain = process.env.REACT_APP_DOMAIN_API;
    const withSSL = process.env.REACT_APP_SSL;

    useEffect(()=>{
        console.log("vinos:: ");
        console.log(wines);
    },[wines])

    /*useEffect(()=>{

    }, searchTerm);*/
    
    const get_list_objects = async () => {
        console.log("q");
        try {
            const response = await axios.get(`http${withSSL}://${apiDomain}/api/no_auth/wines/`);

            let response_wines = response.data;

            response_wines.forEach(wine => {
                wine.precio = wine.precio === null || wine.precio === null ? 0 : wine.precio;
            });
            
            setWines(response_wines);
            setFilteredWines(response_wines); // Inicialmente mostrar todos los vinos

            await axios.get(`http${withSSL}://${apiDomain}/api/no_auth/media_content/8/`).then(
                response => {
                    const imagenes = response.data[0].imagenes.map(imagen => imagen.imagen);
                    console.log(imagenes);
                    setImagesForCarousel(imagenes)
                }
            ).catch(
                error => console.log(error)
            )
        } catch (error) {
            console.log(error);
        }
    }

    // Función para manejar cambios en la entrada del usuario
    const handleSearchInput = (e) => {
        console.log("handleSearchInput: ");
        const term = e.target.value;
        setSearchTerm(term);

        // Filtrar los vinos basándose en el término de búsqueda o mostrar todos si no hay término
        const filtered = term
        ? wines.filter((wine) => {
            let output;
            if(filteredOption === 0){
                output = wine.nombre.toLowerCase().includes(term.toLowerCase());
            }
            if(filteredOption === 1){
                output = wine.pais.toLowerCase().includes(term.toLowerCase());
            }
            if(filteredOption === 2){
                output = wine.tipo.toLowerCase().includes(term.toLowerCase());
            }
            if(filteredOption === 3){
                output = wine.variedad.toLowerCase().includes(term.toLowerCase());
            }
            if (filteredOption === 4) {
                output = wine.precio > parseInt(term);
            }

            //console.log(wine);
            //console.log(filteredOption);
            
            return output;
        })
        : wines;

        setFilteredWines(filtered);
    };

    const handleFilteredOptionForSearch = (option) => {
        console.log(`option for filtered search: ${option}`);
        setFilteredOption(option);

        if(option === 0 && wines.length > 0){
            document.getElementById("search_input_wines").disabled = false;
            setFilteredOptionString('nombre');
            setFilteredWines(wines);
        }
        if(option === 1 && wines.length > 0){
            document.getElementById("search_input_wines").disabled = false;
            setFilteredOptionString('país');
            setFilteredWines(wines);
        }
        if(option === 2 && wines.length > 0){
            document.getElementById("search_input_wines").disabled = false;
            setFilteredOptionString('tipo');
            setFilteredWines(wines);
        }
        if(option === 3 && wines.length > 0){
            document.getElementById("search_input_wines").disabled = false;
            setFilteredOptionString('variedad');
            setFilteredWines(wines);
        }
        if(option === 4 && wines.length > 0){
            document.getElementById("search_input_wines").disabled = true;
            setFilteredOptionString('V. Copeo');
            setSearchTerm("");
            // Filtrar los vinos basándose en el término de búsqueda o mostrar todos si no hay término
            const filtered = wines.filter((wine) => {
                return wine.precio > parseInt(0);
            })

            setFilteredWines(filtered);
        }
    };

    useEffect(() => {
        get_list_objects();
        handleFilteredOptionForSearch(0);
    }, []);

    return (
        <div>
            <article id="container-article1">
            </article>
            {
                wines.length > 0 ?
                <ContainerArticle style={{
                paddingTop: "60px"
                }}>
                    
                    <ContainerSearchInput>
                        <SearchInput
                            id="search_input_wines"
                            type="text"
                            placeholder={`Buscar vino por ${filteredOptionString}...`}
                            value={searchTerm}
                            onInput={handleSearchInput}
                        />
                    </ContainerSearchInput>
                    <ContainerFilteredOptionsForSearch> 
                        <FilteredOptionsForSearch onClick={()=> handleFilteredOptionForSearch(0)}>Nombre</FilteredOptionsForSearch>
                        <FilteredOptionsForSearch onClick={()=> handleFilteredOptionForSearch(1)}>País</FilteredOptionsForSearch>
                        <FilteredOptionsForSearch onClick={()=> handleFilteredOptionForSearch(2)}>Tipo</FilteredOptionsForSearch>
                        <FilteredOptionsForSearch onClick={()=> handleFilteredOptionForSearch(3)}>Variedad</FilteredOptionsForSearch>
                    </ContainerFilteredOptionsForSearch>
                    <ContainerFilteredOptionsForSearch style={{
                        marginTop: "2px"
                    }}> 
                        <FilteredOptionsForSearch onClick={()=> handleFilteredOptionForSearch(4)}>V. Copeo</FilteredOptionsForSearch>
                    </ContainerFilteredOptionsForSearch>
                    <ContainerWines>
                        {filteredWines.length > 0 ? (
                            filteredWines.map((object, index) => (
                                document.getElementById("container-article1").scrollIntoView({
                                    behavior: "smooth", // Hace el desplazamiento suave
                                    block: "start" // Alinea la parte superior del div en la parte superior de la ventana
                                }),
                                <Wine wine={object} index={index} key={index} />
                            ))
                        ) : (
                            <div style={{
                                height: "100vh",
                                overflow: "hidden",
                                display: "flex",
                                alignItems: "start",
                                justifyContent: "center"
                            }}>
                                <SpanForListItemsNull>No hay vinos que coincidan con la búsqueda.</SpanForListItemsNull>
                            </div>
                        )}
                    </ContainerWines>
                </ContainerArticle>
                :
                <div style={{
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "2rem"
                }}>
                    <span>Cargando ...</span>
                </div>
            }
        </div>
    );
}

export default Item8InFoodMenu;